import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import bookingSlot from '../../../../public/assets/slot-booking.svg';

function SlotBooking({ remoteConfigData }) {
  const router = useRouter();
  const handleRedirect = () => {
    router.push('/slot-booking');
  };
  return (
    <section className="pt-[34px] lg:pt-[52px] pr-5 lg:pr-0">
      <div className="mb-[18px] lg:mb-[34px] items-center">
        <h2 className="xl:text-2xl text-lg font-semibold leading-7">
          {remoteConfigData?.heading}
        </h2>
        <p className="xl:text-[18px] text-base text-greyFont font-light leading-5 mt-2">
          {remoteConfigData?.subHeading}
        </p>
      </div>
      <div className="border border-[#B8E5FF] rounded-lg relative bg-white">
        <div className="flex flex-row gap-6 items-center justify-between mb-7 mx-4 lg:m-6">
          <div className="flex items-center justify-center gap-3">
            <Image
              width={100}
              height={100}
              src={bookingSlot}
              alt="Book Placeholder"
            />
            <p className="text-[16px] lg:text-[18px] font-semibold pt-1">
              Book Your Academic Counselling Session Today
            </p>
          </div>
          <button type="button" className="block lg:hidden bg-customBlue text-white text-xs font-medium py-1 px-2 rounded absolute right-3 bottom-3" onClick={handleRedirect}>
            Book Now
          </button>
          <button
            type="button"
            className="hidden lg:block bg-customBlue text-white text-sm font-medium py-1 lg:py-2 bottom-0 px-3 rounded"
            onClick={handleRedirect}
          >
            Book Now
          </button>
        </div>
      </div>
    </section>
  );
}

SlotBooking.propTypes = {
  remoteConfigData: PropTypes.shape({
    heading: PropTypes.string,
    subHeading: PropTypes.string,
  }),
};

export default SlotBooking;
